module.exports = __webpack_public_path__ + "img/Welcome3.0dbc1d5a.png";